import type { SxProps, Theme, TypographyVariant } from "@mui/material";
import { Box, Grid, Stack, Typography } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";

interface Props {
  caption?: string | JSX.Element | undefined;
  captionVariant?: TypographyVariant;
  actions?: JSX.Element;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
}

export const PartContainer = (props: PropsWithChildren<Props>) => {
  const { children, caption, captionVariant, actions, sx, containerSx } = props;

  return (
    <Box sx={{ display: "flex", flex: 1, borderRight: 1, borderRightColor: "divider", py: "1.3rem", ...sx }}>
      <Box sx={{ display: "flex", flex: 1, flexDirection: "column", ...containerSx }}>
        <Grid container sx={{ alignItems: "center", width: "100%" }}>
          <Typography variant={captionVariant ?? "h6"}>{caption}</Typography>
          <HorizontalFill />
          <Stack>{actions}</Stack>
        </Grid>
        {children}
      </Box>
    </Box>
  );
};

export default PartContainer;
